import { HttpClient, JSON_STRING, MHTTPCL } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const BookingSettingsService = {
  findBookingSettings: () => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    output: JSON_STRING,
  }),
  findBookingSettingsTab: () => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'settings_booking_settings_tab_booking_settings',
    output: JSON_STRING,
  }),
  findBookingStatusDetails: ({
    booking_status_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'edit_status',
    booking_status_id,
    output: JSON_STRING,
  }),
  findRequestSettingsData: () => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'load_booking_settings_request_settings',
    output: JSON_STRING
  }),
  findLocalDetailsSettings: () => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'load_bookinglocaldetails_settings',
    output: JSON_STRING,
  }),
  findLocalDetailsSettingsVal: () => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'get_bookinglocaldetails_settings',
    output: JSON_STRING,
  }),
  findBookingTaskSettingsVal: () => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'tasks_tab'
  }),
  findBookingTaskTemplateFormData: ({ task_template_id }) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_form',
    task_template_id
  }),
  addUpdateBookingTaskTemplate: (taskTemplate) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_add_update',
    ...taskTemplate
  }),
  deleteBookingTaskTemplate: (task_template_id) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_delete',
    task_template_id
  }),
  getTaskTemplatesOfGroup: (task_group_id) => HttpClient.get(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_templates_of_group',
    task_group_id
  }),
  addUpdateBookingTaskTemplateGroup: (taskGroup) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_group_add_update',
    ...taskGroup
  }),
  deleteBookingTaskTemplateGroup: (task_group_id) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_group_delete',
    task_group_id
  }),
  addTaskToTaskTemplateGroup: ({ task_group_id, task_template_id,external_table='booking' }) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_add_to_group',
    task_group_id,
    task_template_id,
    external_table
  }),
  removeTaskFromTaskTemplateGroup: ({ task_group_id, task_template_id }) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'task_template_remove_from_group',
    task_group_id,
    task_template_id
  }),
  findMoneyDetailsSettings: () => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'get_invoice_items_details',
    output: JSON_STRING,
  }),
  findInvoiceItemDetails: ({
    invoice_item_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'show_invoice_item_form',
    invoice_item_id,
    output: JSON_STRING,
  }),
  findAccountingSettingsInvoiceItems: () => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'settings_accounting_settings_invoice_items',
    output: JSON_STRING,
  }),
  findInvoiceGroupDetails: ({
    group_name
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'get_invoice_group_items',
    group_name,
    output: JSON_STRING,
  }),

  findSharingData: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'sharing',  
    output: JSON_STRING,
  }),
    
  getRssData:(artist_id)=>MHTTPCL.get(SETTINGS_URL,{
    section:'sharing',
    action: 'create_rss',
    artist_id: artist_id
  }),

  getRssJson:(url) => HttpLib.get(url)
}